import {injectable, registry} from "tsyringe";
import {ProjectDTO} from "../domain/dtos/project.dto";
import {Project} from "../domain/entities/project.entity";
import {TransformerInterface} from "./transformerInterface";

@injectable()
@registry([{
    token: `transformer.project_dto`,
    useToken: ProjectToProjectDtoTransformer
}])
export class ProjectToProjectDtoTransformer implements TransformerInterface<ProjectDTO, Project> {

    public async transform(project: Project): Promise<ProjectDTO> {
        const projectDTO = <ProjectDTO>{
            uid: project.uid,
            type: project.type.uid,
            url: project.url,
            title: project.title,
            timeFrames: [], //await Promise.all(project.timeFrames.map(async timeFrame => container.resolve<TimeFrameToDtoTransformer>(`transformer.time-frame_dto`).transform(timeFrame))),
            createdAt: project.createdAt.toUTC().toSQL(),
            sorting: project.sorting,
            creator: project.creator?.uid ?? null,
            employees: project.employees.map(e => e.uid),
            color: project.color,
            // Also needed for an update: the DTO is reduced to the changed keys afterwards (feature plan 0074).
            textColor: project.textColor,
            description: project.description,
            shortcut: project.shortcut,
        }

        return Promise.resolve(
            project.isNew()
                ? projectDTO
                : this._reduceToChangedValues(project, projectDTO)
        );
    }

    private _reduceToChangedValues(inputObject: Project, projectDTO: ProjectDTO): ProjectDTO {
        return Object
            .fromEntries(
                Object
                    .entries(projectDTO)
                    .filter(
                        ([key]) => inputObject.changedValues.includes((key as keyof Project)) || key === 'uid'
                    )
            ) as ProjectDTO
    }
}